import {Component, OnInit} from '@angular/core';
import {Keys, StorageService} from '../service/storage.service';
import {LoanDetailsService} from '../service/loan-details.service';
import * as moment from 'moment';

@Component({
    selector: 'app-loan-matured',
    templateUrl: './loan-matured.component.html',
    styleUrls: ['./loan-matured.component.css']
})
export class LoanMaturedComponent implements OnInit {

    loanDetails: any;
    loanClosureDate: string;

    private readonly storageService: StorageService;
    private readonly loanDetailsService: LoanDetailsService;

    constructor(storageService: StorageService,
                loanDetailService: LoanDetailsService) {
        this.storageService = storageService;
        this.loanDetailsService = loanDetailService;
    }

    async ngOnInit(): Promise<void> {
        const loanId = this.storageService.getItem(Keys.LOAN_ID);
        this.loanDetails = (await this.getLoanDetails(loanId)).loan_info;
        this.loanClosureDate = moment(this.getLoanClosureDate(this.loanDetails.emi_schedule))
            .format('DD MMM YYYY');
    }

    async getLoanDetails(loanId: string) {
        return await this.loanDetailsService.getLoanDetails(loanId);
    }

    getLoanClosureDate(emi_schedule: any): string {
        return emi_schedule[emi_schedule.length - 1].paid_on;
    }

}
